import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { Role } from '../types';

export class RoleService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getRoles(): Promise<{ roles: Role[] }> {
    return this.api.get(`roles`);
  }

  public async getOrganisationRoles(): Promise<Role[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/roles`);
  }
}

export default new RoleService();
